<template>
  <div class="rootDiv">
    <div class="infoStyle">
      <span class="titleSpan">{{ requestData.title }}</span>
      <div class="phoneInfo">
        <Span class="secondSpan">已向 +86 </Span>
        <Span class="thirdSpan">{{ `${requestData.phone}` }}</Span>
        <Span> 发送验证码</Span>
      </div>
    </div>
    <Field class="fieldStyle" label="验证码" placeholder="请输入验证码" v-model="input_code"
           @keyup.native.capture="activeLogin()"></Field>
    <a class="reSend" @click="reSendVerifyCode">{{ getCodeBtnText }}</a>
    <div class="buttonDiv">
      <Button :disabled="isLoginForbidden" class="submitButton" type="primary" size="large" @click="getBackWithCode">
        提交
      </Button>
    </div>
  </div>
</template>

<script>
import {Button, Field} from 'mint-ui';

export default {
  name: "VerificationCode",
  components: {Field, Button},
  data() {
    return {
      requestData: {
        title: null,
        phone: null,
        ver_code_ide: '0',
        nextPage: null,
        business: null,
        data: null,
      },
      //用户输入的验证码
      input_code: "",

      //倒计时
      countDownTime: 60,
      timeOut: true,
      timer: null,

      //登录按钮禁用
      isLoginForbidden: true,
      // 获取验证码按钮禁用
      getCodeDisabled: true,
      // 获取验证码按钮文字
      getCodeBtnText: null,
      countdownIng: false,
      checkVerifyCodeurl: '/api/verifyCode/checkVerifyCode',
      verifyCodeUrl: '/api/verifyCode/getVerifyCode',
    }
  },
  mounted() {
    if (this.$route.query.requestData !== undefined && this.$route.query.requestData !== null) {
      this.requestData = JSON.parse(this.$route.query.requestData || null)
      let sendEndTime = localStorage.getItem(`startTime${this.requestData.ver_code_ide}`);
      if (sendEndTime) {
        this.countdown();
      } else {
        this.getCodeBtnText = '重新发送'
      }
    } else {
      this.$router.replace('/m_birthday')
    }
  },
  methods: {
    reSendVerifyCode() {
      if (this.getCodeBtnText === '重新发送') {
        this.countdown();
        let that = this
        that.$ajax({
          method: 'get',
          url: this.verifyCodeUrl,
          params: {phoneNumber: this.requestData.phone, key: this.requestData.business}
        }).then((response) => {
          if (response.data.result) {
            this.$toast({
              message: response.data.message,
              position: 'middle',
            });
          } else {
            this.$messagebox.alert(response.data.message)
          }
        }).catch(response => {
          this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
        })
      }
    },
    activeLogin() {
      //判空
      let code = this.input_code
      let code_empty = code === "" || code === null || code === undefined;
      if (code && code.length === 6) {
        //激活登录按钮
        this.isLoginForbidden = code_empty
      }
    },
    getBackWithCode() {
      let that = this
      that.$ajax({
        method: 'get',
        url: that.checkVerifyCodeurl,
        params: {phoneNumber: that.requestData.phone, key: that.requestData.business, code: that.input_code}
      }).then((response) => {
        if (response.data.result) {
          this.$router.replace({
            name: that.requestData.nextPage,
            params: {code: 'cdjcaivi', data: that.requestData.data}
          })
        } else {
          this.$messagebox.alert(response.data.message)
        }
      }).catch(response => {
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    countdown() {
      let that = this;

      let startTime = localStorage.getItem(`startTime${this.requestData.ver_code_ide}`);
      let nowTime = new Date().getTime();
      if (startTime) {
        let surplus = 60 - parseInt((nowTime - startTime) / 1000, 10);
        this.countDownTime = surplus <= 0 ? 0 : surplus;
      } else {
        this.countDownTime = 60;
        localStorage.setItem(`startTime${this.requestData.ver_code_ide}`, nowTime);
      }

      that.timer = setInterval(() => {
        that.countDownTime--;
        that.getCodeBtnText = '重新发送(' + that.countDownTime + "秒)";
        that.getCodeDisabled = true;
        that.countdownIng = true;
        if (that.countDownTime <= 0) {
          localStorage.removeItem(`startTime${this.requestData.ver_code_ide}`);
          clearInterval(that.timer);
          that.countDownTime = 60;
          that.timeOut = true;
          that.countdownIng = false;
          that.getCodeDisabled = that.requestData.phone === "";
          that.getCodeBtnText = "重新发送";
        }
      }, 1000)
    },
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background:#F7F7F9')
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  }
}
</script>

<style lang="less" scoped>

.rootDiv {
  text-align: left;
  background-color: transparent;
  margin-top: -0.5rem;
  margin-left: -0.5rem;
  margin-right: -0.5rem;

  .infoStyle {
    background-color: white;
    margin-bottom: 1rem;
    padding-top: 1rem;
    padding-bottom: 1rem;

    .titleSpan {
      margin-left: 1rem;
      font-size: 1.8rem;
    }

    .phoneInfo {
      margin-top: 1rem;
      font-size: 1rem;

      .secondSpan {
        margin-left: 1rem;
      }

      .thirdSpan {
        color: orange;
      }
    }
  }

  .fieldStyle {
    padding-left: 0.5rem;
    margin-bottom: 0.2rem;
    border-width: 1rem;
    border-color: black;
  }

  .reSend {
    color: blue;
    margin-left: 1rem;
    font-size: 0.8rem;
  }

  .buttonDiv {

    .submitButton {
      width: 95%;
      display: block;
      margin: 2rem auto;
    }
  }
}
</style>
